  import {
  FETCHADVERTISEMENTS_SUCCESS,
  FETCHCOUPONS_SUCCESS,
  FETCHVOTINGS_SUCCESS,
  FETCHPOLLINGS_SUCCESS,
  FETCHDEEPLINKS_SUCCESS,
  FETCHADVERTISEMENT_SUCCESS,
  FETCHCOUPON_SUCCESS,
  FETCHVOTING_SUCCESS,
  FETCHPOLLING_SUCCESS,
  FETCHDEEPLINK_SUCCESS,
  FETCHEVENTS_SUCCESS,
  CREATEEVENT_SUCCESS,
  UPDATEEVENT_SUCCESS,
  DELETEEVENT_SUCCESS,
  FETCHVOTINGQUESTIONS,
  FETCHVOTINGQUESTIONS_SUCCESS,
  FETCHPOLLINGQUESTIONS,
  FETCHPOLLINGQUESTIONS_SUCCESS,
  FETCHVOTINGANSWERS,
  FETCHVOTINGANSWERS_SUCCESS,
  FETCHPOLLINGANSWERS,
  FETCHPOLLINGANSWERS_SUCCESS,
  CREATEADVERTISEMENT_SUCCESS,
  UPDATEADVERTISEMENT_SUCCESS,
  DELETEADVERTISEMENT_SUCCESS,
  CREATECOUPON_SUCCESS,
  UPDATECOUPON_SUCCESS,
  DELETECOUPON_SUCCESS,
  CREATEVOTING_SUCCESS,
  UPDATEVOTING_SUCCESS,
  DELETEVOTING_SUCCESS,
  CREATEPOLLING_SUCCESS,
  UPDATEPOLLING_SUCCESS,
  DELETEPOLLING_SUCCESS,
  CREATEDEEPLINK_SUCCESS,
  UPDATEDEEPLINK_SUCCESS,
  DELETEDEEPLINK_SUCCESS,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  advertisements: {},
  coupons: {},
  votings: {},
  pollings: {},
  deepLinks: {},
  minisites: {},
  editingContentId: -1,
  questions: {}
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {

    case FETCHADVERTISEMENTS_SUCCESS: {
      return {
        ...state,
        advertisements: {
          ...state.advertisements,
          [action.applicationId]: action.payload.getAdvertisements
        }
      }
    }

    case FETCHCOUPONS_SUCCESS: {
      return {
        ...state,
        coupons: {
          ...state.coupons,
          [action.applicationId]: action.payload.getCoupons
        }
      }
    }

    case FETCHVOTINGS_SUCCESS: {
      return {
        ...state,
        votings: {
          ...state.votings,
          [action.applicationId]: action.payload.getVotings
        }
      }
    }

    case FETCHPOLLINGS_SUCCESS: {
      return {
        ...state,
        pollings: {
          ...state.pollings,
          [action.applicationId]: action.payload.getPollings
        }
      }
    }

    case FETCHDEEPLINKS_SUCCESS: {
      return {
        ...state,
        deepLinks: {
          ...state.advertisements,
          [action.applicationId]: action.payload.getDeepLinks
        }
      }
    }

    case FETCHADVERTISEMENT_SUCCESS: {
      const applicationId = action.payload.getAdvertisement.application.applicationId;
      const minisiteId = action.payload.getAdvertisement.minisiteId;

      return {
        ...state,
        advertisements: {
          ...state.advertisements,
          [applicationId]: (state.advertisements[applicationId] || [action.payload.getAdvertisement]).map((minisite) => minisite.minisiteId === minisiteId ? action.payload.getAdvertisement : minisite),
        },
        minisites: {
          ...state.minisites,
          [minisiteId]: action.payload.getAdvertisement
        }
      }
    }

    case FETCHCOUPON_SUCCESS: {
      const applicationId = action.payload.getCoupon.application.applicationId;
      const minisiteId = action.payload.getCoupon.minisiteId;

      return {
        ...state,
        coupons: {
          ...state.coupons,
          [applicationId]: (state.coupons[applicationId] || [action.payload.getCoupon]).map((minisite) => minisite.minisiteId === minisiteId ? action.payload.getCoupon : minisite),
        },
        minisites: {
          ...state.minisites,
          [minisiteId]: action.payload.getCoupon
        }
      }
    }

    case FETCHVOTING_SUCCESS: {
      const applicationId = action.payload.getVoting.application.applicationId;
      const minisiteId = action.payload.getVoting.minisiteId;

      console.log('action.payload.getVoting', action.payload.getVoting);

      return {
        ...state,
        votings: {
          ...state.votings,
          [applicationId]: (state.votings[applicationId] || [action.payload.getVoting]).map((minisite) => minisite.minisiteId === minisiteId ? action.payload.getVoting : minisite),
        },
        minisites: {
          ...state.minisites,
          [minisiteId]: action.payload.getVoting
        }
      }
    }

    case FETCHPOLLING_SUCCESS: {
      const applicationId = action.payload.getPolling.application.applicationId;
      const minisiteId = action.payload.getPolling.minisiteId;

      console.log('FETCHPOLLING_SUCCESS', action.payload);

      return {
        ...state,
        pollings: {
          ...state.pollings,
          [applicationId]: (state.pollings[applicationId] || [action.payload.getPolling]).map((minisite) => minisite.minisiteId === minisiteId ? action.payload.getPolling: minisite),
        },
        minisites: {
          ...state.minisites,
          [minisiteId]: action.payload.getPolling
        }
      }
    }

    case FETCHDEEPLINK_SUCCESS: {
      const applicationId = action.payload.getDeepLink.application.applicationId;
      const minisiteId = action.payload.getDeepLink.minisiteId;

      return {
        ...state,
        pollings: {
          ...state.pollings,
          [applicationId]: (state.deepLinks[applicationId] || [action.payload.getDeepLink]).map((minisite) => minisite.minisiteId === minisiteId ? action.payload.getDeepLink: minisite),
        },
        minisites: {
          ...state.minisites,
          [minisiteId]: action.payload.getDeepLink
        }
      }
    }

    case FETCHEVENTS_SUCCESS: {
      return {
        ...state,
        events: {
          ...state.events,
          [action.minisiteId]: action.payload.getEvents
        }
      }
    }

    case FETCHVOTINGQUESTIONS_SUCCESS: {
      console.log('FETCHVOTINGQUESTIONS_SUCCESS', action.payload);
      return {
        ...state,
        questions: {
          ...state.questions,
          [action.minisiteId]: action.payload.getVotingQuestions
        }
      }
    }

    case FETCHPOLLINGQUESTIONS_SUCCESS: {
      console.log('action', action);

      return {
        ...state,
        questions: {
          ...state.questions,
          [action.minisiteId]: action.payload.getPollingQuestionsWithAnswers
        }
      }
    }

    case FETCHVOTINGANSWERS_SUCCESS: {
      return {
        ...state,
        votingAnswers: {
          ...state.votingAnswers,
          [action.votingQuestionId]: action.payload.getVotingAnswers
        }
      }
    }

    case FETCHPOLLINGANSWERS_SUCCESS: {
      console.log('action', action);

      return {
        ...state,
        pollingAnswers: {
          ...state.pollingAnswers,
          [action.pollingQuestionId]: action.payload.getPollingAnswers
        }
      }
    }

    case CREATEEVENT_SUCCESS: {

      return {
        ...state,
        createdEvent: action.payload,
        loader: false
      }
    }

    case UPDATEEVENT_SUCCESS: {

      return {
        ...state,
        updatedEvent: action.payload,
        loader: false
      }
    }

    case DELETEEVENT_SUCCESS: {

      return {
        ...state,
        deleted: action.payload,
      }
    }

    case CREATEADVERTISEMENT_SUCCESS: {

      return {
        ...state,
        createdAdvertisement: action.payload
      }
    }

    case UPDATEADVERTISEMENT_SUCCESS: {

      return {
        ...state,
        updatedAdvertisement: action.payload
      }
    }

    case DELETEADVERTISEMENT_SUCCESS: {

      return {
        ...state,
        deletedAdvertisement: action.payload,
        deletedCoupon: false,
        deletedVoting: false,
        deletedPolling: false,
        deletedDeepLink: false
      }
    }

    case CREATECOUPON_SUCCESS: {

      return {
        ...state,
        createdCoupon: action.payload
      }
    }

    case UPDATECOUPON_SUCCESS: {

      return {
        ...state,
        updatedCoupon: action.payload
      }
    }

    case DELETECOUPON_SUCCESS: {

      return {
        ...state,
        deletedAdvertisement: false,
        deletedCoupon: action.payload,
        deletedVoting: false,
        deletedPolling: false,
        deletedDeepLink: false
      }
    }

    case CREATEVOTING_SUCCESS: {

      return {
        ...state,
        createdVoting: action.payload
      }
    }

    case UPDATEVOTING_SUCCESS: {

      return {
        ...state,
        updatedVoting: action.payload
      }
    }

    case DELETEVOTING_SUCCESS: {

      return {
        ...state,
        deletedVoting: action.payload,
        deletedAdvertisement: false,
        deletedCoupon: false,
        deletedPolling: false,
        deletedDeepLink: false

      }
    }

    case CREATEPOLLING_SUCCESS: {

      return {
        ...state,
        createdPolling: action.payload
      }
    }

    case UPDATEPOLLING_SUCCESS: {

      return {
        ...state,
        updatedPolling: action.payload
      }
    }

    case DELETEPOLLING_SUCCESS: {

      return {
        ...state,
        deletedPolling: action.payload,
        deletedAdvertisement: false,
        deletedCoupon: false,
        deletedVoting: false,
        deletedDeepLink: false
      }
    }

    case CREATEDEEPLINK_SUCCESS: {

      return {
        ...state,
        createdDeepLink: action.payload
      }
    }

    case UPDATEDEEPLINK_SUCCESS: {

      return {
        ...state,
        updatedDeepLink: action.payload
      }
    }

    case DELETEDEEPLINK_SUCCESS: {

      return {
        ...state,
        deletedDeepLink: action.payload,
        deletedAdvertisement: false,
        deletedCoupon: false,
        deletedVoting: false,
        deletedPolling: false,
      }
    }

    default: {
      return {
        ...state,
        minisites: {
        },
        events: {},
        questions: {},
        deletedDeepLink: false,
        deletedAdvertisement: false,
        deletedCoupon: false,
        deletedVoting: false,
        deletedPolling: false,
        updatedAdvertisement: false,
        updatedCoupon: false,
        updatedVoting: false,
        updatedPolling: false,
        updatedDeepLink: false,
        createdAdvertisement: false,
        createdCoupon: false,
        createdVoting: false,
        createdPolling: false,
        createdDeepLink: false
      }
    }
  }
}
